import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  Alert,
  AlertPriority,
  AlertToken,
  IAlertMonitor,
  PresentationType,
  Reminder,
} from "../../redux/alerts/index";
import { presenceStatuses } from "../../redux/residents";
import { residentsCreator } from "../../redux/residents/selectors";
import { IAppState } from "../../redux/types";
import { alertIconToken } from "../../utils/AlertTo";
import { useAlertTimer } from "../../utils/hooks/hooks";
import { AvatarResidentUser } from "../common/AvatarUser";
import {
  DisplayUserInvisibleContainer,
  OverflowTip,
  RoomBedDisplayByMin,
  ViewerInvisibleContainer,
} from "../common/Common";
import "./styles.scss";
import { MarkForResidentAvatar } from "./utils";

export const TimePass = React.memo(
  ({
    alert,
    onlyMinutes = false,
  }: {
    alert: IAlertMonitor | Alert | Reminder;
    onlyMinutes?: boolean;
  }): JSX.Element => {
    const waitStr = useAlertTimer(
      alert["utcDate"]
        ? alert["utcDate"]
        : (alert as unknown as IAlertMonitor)?.date,
      onlyMinutes
    );

    return <span style={{ marginTop: "10px" }}>{waitStr}</span>;
  }
);
TimePass.displayName = "TimePass";
const OneNotificationView = ({
  alert,
  index,
  onDoneClick,
}: {
  alert: IAlertMonitor | Reminder;
  index: number;
  onDoneClick: (alert: Alert | Reminder) => void;
}): JSX.Element => {
  const { presentation } = useSelector(
    (state: IAppState) => state.alerts.settings
  );
  const isReminder = alert["activityType"] !== undefined;
  const reminder = isReminder ? (alert as Reminder) : undefined;
  const al = !isReminder ? (alert as IAlertMonitor) : undefined;
  const ResidentSelection = useMemo(() => residentsCreator(), []);
  const resident = useSelector((state: IAppState) =>
    ResidentSelection(state, al ? al?.patientId : reminder?.residentId)
  );

  const onDoneClickHandler = useCallback(
    (e: any) => {
      if (al && al?.alertToken === AlertToken.UserNearby) return;
      onDoneClick(alert);
    },
    [alert, onDoneClick, al]
  );

  console.log("OneAlertView");
  console.log(presentation);
  const colorBorder = isReminder
    ? "yellow"
    : al?.priority === AlertPriority.high
    ? "red"
    : al?.priority === AlertPriority.med
    ? "black"
    : "yellow";
  const oneCard = (
    <div
      className={`one-notif-card flex-column flex-column-16 ${colorBorder} flex-center ${
        presentation === 0 ? "notif-height" : ""
      }`}
      onClick={onDoneClickHandler}
      style={{ marginTop: index !== 0 ? "24px" : "" }}
    >
      <React.Suspense fallback={<p></p>}>
        <div className="flex-column">
          {/*  flex-gap-8 flex-gap*/}
          <div className="flex-center">
            <AvatarResidentUser profile={resident} size={"24"}>
              <MarkForResidentAvatar resident={resident} />
            </AvatarResidentUser>
            <RoomBedDisplayByMin
              devicesMinimized={resident.devicesMinimized}
              isActive={resident.nodePresence === presenceStatuses.active}
            />
          </div>

          <OverflowTip
            text={[resident?.firstName, resident.lastName].join(" ")}
          />
        </div>
      </React.Suspense>
      <div
        className="flex-column flex-center flex-column-8"
        style={{ marginTop: "12px" }}
      >
        <React.Suspense fallback={<p></p>}>
          <div className="flex-gap flex-center flex-gap-8">
            {al && (
              <div className="alert-44">{alertIconToken(al.alertToken)}</div>
            )}
            {reminder && (
              <>
                <div className="alert-44">
                  <i
                    className={`icon-alert info icon-action-${reminder.activityType}`}
                  />
                </div>
              </>
            )}
            {al?.priority !== AlertPriority.med && (
              <ViewerInvisibleContainer>
                <DisplayUserInvisibleContainer>
                  <button
                    className="btn primary btn-icon size-btn"
                    style={{ marginLeft: "8px", maxWidth: "none" }}
                  >
                    <i className="icon-check"></i>
                  </button>
                </DisplayUserInvisibleContainer>
              </ViewerInvisibleContainer>
            )}
          </div>
        </React.Suspense>
        <TimePass alert={alert} onlyMinutes={false} />
      </div>
    </div>
  );
  const oneRow = (
    <div
      className={`one-notif-card flex-between  ${colorBorder}`}
      style={{ marginTop: index !== 0 ? "8px" : "" }}
      onClick={onDoneClickHandler}
    >
      <AvatarResidentUser
        profile={resident}
        // size={"40"}
        size={presentation === 2 ? "24" : "40"}
      >
        <MarkForResidentAvatar resident={resident} />
      </AvatarResidentUser>
      <RoomBedDisplayByMin
        devicesMinimized={resident.devicesMinimized}
        isActive={resident.nodePresence === presenceStatuses.active}
      />
      {al && <div className="alert-24">{alertIconToken(al.alertToken)}</div>}
      {reminder && (
        <>
          <div className="alert-24">
            <i
              className={`icon-alert info icon-action-${reminder.activityType}`}
            />
          </div>
        </>
      )}
    </div>
  );
  const oneTile = (
    <div
      className={`one-notif-tile ${colorBorder} tile-position`}
      onClick={onDoneClickHandler}
    >
      <AvatarResidentUser profile={resident} size={"40"} view={"tile"}>
        <div className="status-holder status-position">
          {al && (
            <div className="alert-24">{alertIconToken(al.alertToken)}</div>
          )}
          {reminder && (
            <>
              <div className="alert-24">
                <i
                  className={`icon-alert info icon-action-${reminder.activityType}`}
                />
              </div>
            </>
          )}
        </div>
      </AvatarResidentUser>
    </div>
  );
  return presentation === PresentationType.Cards
    ? oneCard
    : presentation === PresentationType.List
    ? oneRow
    : oneTile;
};

export default React.memo(OneNotificationView);
